<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-progress-linear v-if="$apollo.loading" indeterminate />
      <highcharts v-if="socialActions" :options="socialActionsReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import { SOCIAL_ACTIONS_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "SocialActions",
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    gymBranch: {
      type: [Number, String],
    },
  },
  data() {
    return {
      socialActions: null,
    };
  },
  computed: {
    socialActionsReport() {
      let series = this.socialActions.map((x) => {
        return {
          name: x["cohort"],
          data: x["engagement"].map((c) => [c["actionDate"], parseInt(c["userCount"])]),
        };
      });
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "Social Actions",
        },
        xAxis: {
          categories: this.socialActions[0].engagement.map((x) => x["actionDate"]),
        },
        yAxis: {
          title: {
            text: "# of users",
          },
        },
        credits: {
          enabled: false,
        },
        series: series,
      };
    },
  },
  apollo: {
    socialActions: {
      query: SOCIAL_ACTIONS_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          gymBranch: this.gymBranch,
        };
      },
    },
  },
};
</script>
